import endpoints from "@config/endpoints";
import { benef_life_calendar_const } from "@constants/beneficiaryConstant";
import { getData } from "@services/CommonApiService";
import { errorLogger } from "@utils/applicationLogUtils";
import { toast } from "react-toastify";

export const getBeneficiaryLifeCalenderDataApi = async (benefId: any) => {
    try {
        const res = await getData<any>(`${endpoints.getBeneficiaryLifeEventDetailsByBenefId}/${benefId}`);
        if (res && (res.data && res.data.length > 0)) {
            return res;
        } else {
            return null
        }
    } catch (error: any) {
        toast.error(benef_life_calendar_const.errorMessageForLifeCalendar, {
            position: 'top-center',
        });
        errorLogger(error?.response?.data || error?.response || error);
    }
};